export default {
	/**
   * Flag para se o toast deve ser mostrado 
   */
	showToast(state)
	{
		return state.toast?.show ?? false;
	},
	/**
   * Tipo do toast.
   */
	toastType(state)
	{
		return state.toast?.type ?? "default";
	},

	/**
   * Mensagem do Toast.
   */
	toastMessage(state)
	{
		return state.toast?.message ?? "";
	},
	/**
	 * Determina cor se basendo no retorno dos status
	 */
};
